import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { SandboxView } from '~/capitalProvider/domains/settings/sandbox/SandboxView';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { SettingsFacilityBorrowingBaseTemplate } from '~/packages/settings/ui/SettingsFacilityBorrowingBaseTemplate';

import 'source/borrower/borrower.scss';

// Types
const RouteParamsStruct = z.object({
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { creditFacilityId } = RouteParamsStruct.parse(params);
  return (
    <SettingsFacilityBorrowingBaseTemplate
      creditFacilityId={creditFacilityId}
      selectedTab="sandbox"
    >
      <SandboxView creditFacilityId={creditFacilityId} />
    </SettingsFacilityBorrowingBaseTemplate>
  );
};

// Exports
export const Route = () => {
  const flags = useFeatureFlags();
  if (!flags.displayLenderSettingsFacilities) {
    return <Navigate to="/settings" />;
  }
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/credit-facilities" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
